import {
  GRID_MARKER,
  ScheduleDisplayMode,
  ScheduleGridData,
  ScheduleGridRow,
  WEEK_DAYS,
  WeekDay,
} from "../types/schedule";

export function emptyGridRow(promotion = ""): ScheduleGridRow {
  const days = {} as Record<WeekDay, string>;
  WEEK_DAYS.forEach((d) => { days[d] = ""; });
  return { promotion, days };
}

export function defaultGridData(facultyName = ""): ScheduleGridData {
  return {
    weekLabel: "",
    facultyName,
    rows: [
      emptyGridRow("L0"),
      emptyGridRow("L1"),
      emptyGridRow("L2 Tous"),
      emptyGridRow("L3"),
      emptyGridRow("M1"),
      emptyGridRow("M2"),
    ],
  };
}

export function parseScheduleDescription(description?: string | null): {
  mode: ScheduleDisplayMode;
  grid: ScheduleGridData | null;
  notes: string;
} {
  const raw = (description || "").trim();
  if (!raw.startsWith(GRID_MARKER)) {
    return { mode: "document", grid: null, notes: raw };
  }
  const jsonPart = raw.slice(GRID_MARKER.length).split("\n---\n")[0];
  const notes = raw.includes("\n---\n") ? raw.split("\n---\n").slice(1).join("\n---\n") : "";
  try {
    const grid = JSON.parse(jsonPart) as ScheduleGridData;
    if (grid?.rows?.length) return { mode: "grid", grid, notes };
  } catch {
    /* fall through */
  }
  return { mode: "document", grid: null, notes: raw };
}

export function serializeGridDescription(grid: ScheduleGridData, notes = ""): string {
  const base = `${GRID_MARKER}${JSON.stringify(grid)}`;
  const trimmed = notes.trim();
  return trimmed ? `${base}\n---\n${trimmed}` : base;
}

export function getScheduleDisplayMode(item: { description?: string; displayMode?: string }): ScheduleDisplayMode {
  if (item.displayMode === "grid" || item.displayMode === "document") return item.displayMode;
  return parseScheduleDescription(item.description).mode;
}

export function getScheduleGrid(item: { description?: string; gridData?: ScheduleGridData }): ScheduleGridData | null {
  if (item.gridData?.rows?.length) return item.gridData;
  return parseScheduleDescription(item.description).grid;
}
